import {useState, useEffect} from 'react';

import {RadioGroupItemConfig} from 'filters/features/FilterTopbar/types';
import {assertPageFilter} from 'filters/types';

import {useSourceFilter, useFilterLoading} from 'filters/contexts/FilterStackProvider';
import {useFilterActionsContext} from 'filters/contexts/FilterActionsProvider/FilterActionsProvider';

import {RadioGroup} from 'components/RadioGroup';

import {BaseFilterTopBarItem} from 'modules/decisionsNext/components/BaseFilter/TopBar/BaseFilterTopBarItem';

export const createRadioGroupItem = <V,>(config: Omit<RadioGroupItemConfig<V>, 'type'>): RadioGroupItemConfig<V> => {
  return {
    ...config,
    type: 'radio-group' as const,
  };
};

export const RadioGroupItem = ({
  getLabel,
  getValue,
  dropdownLabel,
  options,
  onApply,
  variant,
}: RadioGroupItemConfig<any>) => {
  const filter = useSourceFilter();
  const loading = useFilterLoading();
  const {useApplyFilter} = useFilterActionsContext();
  const onFilterApply = useApplyFilter();

  const value = getValue?.(filter);
  const [dropdownValue, setDropdownValue] = useState(() => value);

  useEffect(() => {
    setDropdownValue(value);
  }, [value]);

  return (
    <BaseFilterTopBarItem
      loading={loading}
      label={getLabel(value)}
      dropDownTitle={dropdownLabel}
      variant={variant}
      onApply={() => {
        assertPageFilter(filter);

        onFilterApply(onApply(filter, dropdownValue));
      }}
      onExited={() => setDropdownValue(value)}
    >
      <RadioGroup
        variant='dropdown-options'
        value={dropdownValue}
        onChange={(_, value) => setDropdownValue(value)}
        options={options}
      />
    </BaseFilterTopBarItem>
  );
};
